import { t } from "@lingui/macro";
import React, { useState } from "react";

import { Box, HStack, Text, VStack } from "../../../../primitive";
import { ToggleSwitch } from "../../../ToggleSwitch";

type Props = {
  labelOverride?: string;
  onToggle: (isChecked: boolean) => void;
  initiallyChecked?: boolean;
};
export const OptionalToggle = ({
  labelOverride,
  onToggle,
  initiallyChecked = false,
}: Props) => {
  const [isChecked, setIsChecked] = useState(initiallyChecked);
  const label = labelOverride ?? t`Apply to everyone`;

  const handleToggle = () => {
    setIsChecked(!isChecked);
    onToggle(!isChecked);
  };

  return (
    <VStack paddingHorizontal={3}>
      <HStack
        paddingVertical={4}
        justifyContent="space-between"
        alignItems="center"
      >
        <Text>{label}</Text>
        <ToggleSwitch
          isChecked={isChecked}
          onToggle={handleToggle}
          accessibilityLabel={label}
        />
      </HStack>
      <Box height={1} backgroundColor="surface-dividers" marginVertical={1} />
    </VStack>
  );
};
